import script from "./index - 副本.vue?vue&type=script&setup=true&lang=js"
export * from "./index - 副本.vue?vue&type=script&setup=true&lang=js"

import "./index - 副本.vue?vue&type=style&index=0&id=bb08f2f0&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\agent-yuyooke\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb08f2f0"]])

export default __exports__